import React from "react";
import { liveTopics } from "../../data/program";
export function Mentorship() {
  return <section className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:py-28" data-id="element-119" data-mp="2zf0ayb0van9r">
      <div className="grid gap-12 md:grid-cols-2 md:gap-20" data-id="element-120" data-mp="2zgtkby2v7llg">
        <div data-id="element-121" data-mp="3dft8l4mgtyh3">
          <h2 className="font-display text-4xl font-black uppercase leading-none md:text-5xl" data-id="element-122" data-mp="3dfjhtetljnac">Pero CLARIFY no termina en la plataforma.</h2>
          <p className="mt-6 text-xl text-paper" data-id="element-123" data-mp="3nc61w1e3mabb">Cada semana nos vamos a encontrar en vivo.</p>
          <p className="mt-3 text-lg text-paper/70" data-id="element-124" data-mp="3idky5rzn18i4">Porque hay cosas que ningún video puede enseñarte.</p>
        </div>
        <ul className="space-y-3 text-lg" data-id="element-125" data-mp="3w4zic25a7fqr">
          {liveTopics.map(t => <li key={t} className="flex gap-4 border-b border-line pb-3" data-id="element-126" data-mp="3s3eboyjcbxp0">
              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" aria-hidden data-id="element-127" data-mp="3s5ibp5e4cck0" />
              {t}
            </li>)}
        </ul>
      </div>

      <div className="mt-14 grid overflow-hidden rounded-2xl border border-line md:mt-20 md:grid-cols-2" data-id="element-128" data-mp="4zrgr2bntpqy">
        <div className="p-6 md:p-12" data-id="element-129" data-mp="1msbyyhismhtb">
          <p className="text-base text-paper/70 md:text-lg" data-id="element-130" data-mp="1rpubehw0rf62">La plataforma te enseña:</p>
          <p className="mt-3 font-display text-3xl font-black uppercase md:text-5xl" data-id="element-131" data-mp="1rrotlofwot6g">Qué hacer.</p>
        </div>
        <div className="bg-accent p-6 text-ink md:p-12" data-id="element-132" data-mp="20qjymx77rx86">
          <p className="text-base text-ink/70 md:text-lg" data-id="element-133" data-mp="20s3g2r4lwebj">Las mentorías en vivo te ayudan con:</p>
          <p className="mt-3 font-display text-3xl font-black uppercase md:text-5xl" data-id="element-134" data-mp="25p3np6h3tp4r">Cómo seguir haciéndolo.</p>
        </div>
      </div>
    </section>;
}